import React from 'react'; 
import CommitmentItem from './CommitmentItem';
 
const CommitmentHistory = (props) => {
    const {data, isFromPreview} = props;

    return(
        <div>
            <div className="row around-xs inputPair">
                <div className='tbl-bank-balance-header'>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className='bank-balance-col1 item-float-left'>
                            Product Type
                        </div>
                        <div className='bank-balance-col2 item-float-left'>
                            No. of Banks
                        </div>
               
                        <div className='bank-balance-col4 item-float-left'>
                           Amount
                        </div>
                        {(isFromPreview === false)&&
                        <div className='bank-balance-col5 item-float-left'>
                            Actions
                        </div>
                        }
                    </div>
                </div>
            </div>
            {(data.length === 0)?
            <div className="row around-xs inputPair">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className='txt-center'>
                        {isFromPreview?
                        <>No Record</>
                        :
                        <>Click ‘Add Commitment Details’ to begin.</>
                        }
                        
                    </div>
                </div>
            </div>
            :
           <div>
                {data.map((item, idx) => (
                <CommitmentItem key={idx} item={item} isFromPreview={isFromPreview}
                    onClick={(v)=> {
                    props.onItemClick(v,idx,item);
                    }}/>
                ))}
          </div>
            }
        </div>
    )
}

export default CommitmentHistory;